<nav class="layout-breadcrumb ml-5 mt-5">
  <ol class="">
    <!-- <li >
      <img src="assets/img/nube_cc_200x140.png" width="32px"/>
    </li> -->
    <ng-template
      ngFor
      let-item
      let-last="last"
      [ngForOf]="breadcrumbs$ | async"
    >
      <li *ngIf="!last">
        <a routerLink="{{ item.url }}"> {{ item.label }}</a>
      </li>
      <li *ngIf="last">{{ item.label }}</li>
      <li *ngIf="!last" class="layout-breadcrumb-chevron">/</li>
    </ng-template>
  </ol>
</nav>
